var map = {
	"./404.vue": [
		23
	],
	"./AboutUs.vue": [
		104
	],
	"./Archive.vue": [
		145
	],
	"./Article.vue": [
		97
	],
	"./CalendarTemplate.vue": [
		105
	],
	"./DefaultPage.vue": [
		102
	],
	"./GameFree/GameFree.vue": [
		101
	],
	"./GameGuideHolder.vue": [
		100
	],
	"./Home.vue": [
		141
	],
	"./HomeLayout1.vue": [
		78
	],
	"./HomeLayout2.vue": [
		79
	],
	"./Index.vue": [
		142
	],
	"./MapTemplate.vue": [
		103
	],
	"./News/News.vue": [
		109
	],
	"./PaymentOptions/PaymentOptions.vue": [
		106
	],
	"./Preview.vue": [
		144
	],
	"./Promotions/Promotions.vue": [
		108
	],
	"./Review/Review.vue": [
		98
	],
	"./Review/ReviewWithBlocks.vue": [
		99
	],
	"./Search/Search.vue": [
		143
	],
	"./SoftwareProviders/SoftwareProviders.vue": [
		107
	],
	"./Streams/Streams.vue": [
		110
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 706;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*\.vue$
// module id = 706
// module chunks = 1